package fyi.moko.hotpl.domain.model

/**
 * A place the user has actually felt [emotion] at, surfaced in answer to "지금 나에게
 * 맞는 곳이 어디지?" (§1.4 회복 루프).
 *
 * Computed (not stored) — produced by
 * [fyi.moko.hotpl.domain.usecase.RechargePlaceSelector] from the visit history that
 * already carries [Visit.emotion]. Pure value, no platform references.
 *
 * @property matchingVisitCount How many of this place's visits carried [emotion].
 *   The primary evidence: three serene visits beat one.
 * @property totalVisitCount All (non-deleted) visits to the place, so the UI can say
 *   "3 of 5 visits" and the ranking can prefer a place that is *reliably* this feeling
 *   over one that was this feeling once out of many.
 * @property lastMatchedAt Epoch millis of the most recent matching visit. Used for
 *   ordering and for a "last time" line — never to exclude a place for being too
 *   recent (see the selector's docs for why this differs from the revisit window).
 */
data class RechargeCandidate(
    val placeId: String,
    val placeName: String,
    val emotion: Emotion,
    val matchingVisitCount: Int,
    val totalVisitCount: Int,
    val lastMatchedAt: Long,
)
